import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../../shared/shared.module';
import {FavsComponent} from "./favs.component";
import {MpDialogComponent} from "../../theme/components/mp-dialog/mp-dialog.component";
import {VideoDialogComponent} from "../../theme/components/videoDialog/videoDialog.component";
import { MatButtonModule } from '@angular/material';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    MatButtonModule
  ],
  declarations: [
    FavsComponent,
  ],
  exports: [
    FavsComponent,
  ],
})
export class FavsModule {
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/favs/favs.module.ts